export default __webpack_public_path__ + "static/media/not-found.b9f3d78d.avif";